import React from "react";

import { IconButton, Tooltip } from "@mui/material";

import {
  Fullscreen,
  FullscreenExit,
  RestartAlt,
  ZoomIn,
  ZoomOut,
} from "@mui/icons-material";
import { elementHighest } from "core/services/elementService";

const CanvasActions = ({
  type,
  setFullScreenGraph,
  isFullScreen,
  myCanvas,
  defaultSize,
}) => {
  const intervalRef = React.useRef();
  const zoomRef = React.useRef();
  const unzoomRef = React.useRef();

  React.useEffect(() => {
    const zoomDiff = Math.sqrt(
      Math.sqrt(
        Math.sqrt(
          Math.pow(defaultSize.width, 2) + Math.pow(defaultSize.height, 2)
        )
      )
    );
    const performZoom = (dir) => {
      intervalRef.current = setInterval(() => {
        const focusPoint = myCanvas?.selectedTarget?.name
          ? myCanvas.TAG === "NUCLIDE_GRAPH"
            ? myCanvas.getXYFromNP(
                myCanvas.selectedTarget.neutron,
                myCanvas.selectedTarget.proton
              )
            : myCanvas.getXYFromNP(
                myCanvas.selectedTarget.px,
                elementHighest.y - myCanvas.selectedTarget.py
              )
          : {
              x: myCanvas.canvasWidth / 2,
              y: myCanvas.canvasHeight / 2,
            };

        myCanvas.onZoomChange(dir * zoomDiff, focusPoint);
      }, 16);
    };
    const handleZoom = (e) => {
      handleStopZoom(e);
      performZoom(+1);
    };
    const handleUnZoom = (e) => {
      handleStopZoom(e);
      performZoom(-1);
    };
    const handleStopZoom = (e) => {
      e.stopPropagation();
      e.preventDefault();

      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };

    const zoomBtn = zoomRef.current;
    const unzoomBtn = unzoomRef.current;

    if (zoomBtn) {
      zoomBtn.addEventListener("mousedown", handleZoom);
      zoomBtn.addEventListener("mouseup", handleStopZoom);
      zoomBtn.addEventListener("mouseleave", handleStopZoom);
      zoomBtn.addEventListener("touchstart", handleZoom);
      zoomBtn.addEventListener("touchend", handleStopZoom);
    }

    if (unzoomBtn) {
      unzoomBtn.addEventListener("mousedown", handleUnZoom);
      unzoomBtn.addEventListener("mouseup", handleStopZoom);
      unzoomBtn.addEventListener("mouseleave", handleStopZoom);
      unzoomBtn.addEventListener("touchstart", handleUnZoom);
      unzoomBtn.addEventListener("touchend", handleStopZoom);
    }

    return () => {
      if (zoomBtn) {
        zoomBtn.removeEventListener("mousedown", handleZoom);
        zoomBtn.removeEventListener("mouseup", handleStopZoom);
        zoomBtn.removeEventListener("mouseleave", handleStopZoom);
        zoomBtn.removeEventListener("touchstart", handleZoom);
        zoomBtn.removeEventListener("touchend", handleStopZoom);
      }

      if (unzoomBtn) {
        unzoomBtn.removeEventListener("mousedown", handleUnZoom);
        unzoomBtn.removeEventListener("mouseup", handleStopZoom);
        unzoomBtn.removeEventListener("mouseleave", handleStopZoom);
        unzoomBtn.removeEventListener("touchstart", handleUnZoom);
        unzoomBtn.removeEventListener("touchend", handleStopZoom);
      }
    };
  }, [myCanvas, defaultSize]);

  const handleReset = () => {
    myCanvas?.reset();
  };

  return (
    <>
      <Tooltip arrow title="Reset">
        <IconButton color="inherit" size="small" onClick={handleReset}>
          <RestartAlt />
        </IconButton>
      </Tooltip>
      <Tooltip arrow title="Zoom Out">
        <IconButton color="inherit" size="small" ref={unzoomRef}>
          <ZoomOut />
        </IconButton>
      </Tooltip>
      <Tooltip arrow title="Zoom In">
        <IconButton color="inherit" size="small" ref={zoomRef}>
          <ZoomIn />
        </IconButton>
      </Tooltip>

      {setFullScreenGraph &&
        (isFullScreen ? (
          <Tooltip arrow title="Exit Fullscreen" color="primary">
            <IconButton
              color="inherit"
              size="small"
              onClick={() => {
                setFullScreenGraph(null);
              }}
            >
              <FullscreenExit />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip arrow title="Fullscreen">
            <IconButton
              color="inherit"
              size="small"
              onClick={() => {
                setFullScreenGraph(type);
              }}
            >
              <Fullscreen />
            </IconButton>
          </Tooltip>
        ))}
    </>
  );
};

export default React.memo(CanvasActions);
